<template>
    <div class="assignee-wrap">
        <!-- 사용자 프로필 추가 -->
        <span class="user-profile">
            <img :src="userDetail()" alt="user profile">
        </span>
        <!-- 금일 휴가인 assignee는 profile img 우측 상단에 'zzz' img 표시-->
        <span class="assignee-name" v-b-tooltip.hover :title="id">{{ name }}</span>
    </div>
</template>
<script>
export default {
    name: 'UserProfile',
    props :{
        id: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        imagePath: {
            type: String,
            required: false,
            default: '',
        }
    },
    created() {
        this.profileImage = this.getImage();
    },
    data() {
        return {
            defaultProfileImage: require('@/assets/images/icon_user.png'),
            profileImage : '',
        }
    },
    methods: {
        getImage() {
            if(this.imagePath) {
                // TODO API 호출
                try {
                    // let data = null;
                    // let response = await axios.get(`files/${imagePath}/download`, {
                    //     responseType: 'blob',
                    //     headers: { Authorization: accessToken() }
                    // });
                    // data = response.data;
                    // return data = URL.createObjectURL(data) || this.defaultProfileImage;
                    return this.defaultProfileImage;
                } catch (error) {
                    console.log10(error);
                }
            } else {
               return this.defaultProfileImage;
            }
        },

        userDetail() {
            return this.$store.getters['chatter/getUserByUserId'](this.id).profileImg;
        },
    }
}

</script>
<style scoped>
.assignee-wrap {
  display: flex;
  align-items: center;
  gap: 0 0.729vw;
  width: 100%;
  white-space: nowrap;
}
.assignee-wrap .user-profile {
  position: relative;
  /* flex-grow: 1; */
  flex-shrink: 0;
  display: inline-block;
  width: 40px;
  height: 40px;
  overflow: hidden;
  border-radius: 50%;
}

.assignee-wrap .user-profile img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  object-fit: cover;
}
</style>